<template>
  <div class="text-center">
    <v-dialog persistent v-model="visible" width="400">
      <v-card class="not-margin pt-0 pr-0 pl-0">
        <v-toolbar dark color="primary">
          <div class="text-center">
            <v-icon>mdi-eye</v-icon> Visualizar Turno
          </div>
        </v-toolbar>
        <div class="container dialog">
          <v-row class="d-flex justify-center mt-7">
              <v-col cols="12">
                <v-text-field
                  label="Turno"
                  v-model="content.descricao"
                  outlined
                  dense
                  readonly
                  maxlength="25"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  label="Hora de Início"
                  v-model="content.horaInicio"
                  outlined
                  dense
                  readonly
                  v-mask="'##:##'"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  label="Hora de Término"
                  v-model="content.horaFim"
                  outlined
                  dense
                  readonly
                  v-mask="'##:##'"
                ></v-text-field>
              </v-col>
            </v-row>
        </div>
        <div class="btn-group text-center">
          <v-btn color="primary" @click="$emit('onClose')">
            <v-icon>mdi-close</v-icon>
            Fechar
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { DialogProps } from '~/commons/classes/dialog-props';
import { Turno } from '~/commons/classes/turno';

export default {
  props: new DialogProps(Turno),
};
</script>
